import {
  AfterContentInit,
  ChangeDetectorRef,
  Component, effect,
  inject, input,
  model,
  OnDestroy,
  OnInit, signal,
  ViewChild
} from '@angular/core';
import {ButtonComponent, ButtonOptions, ModalComponent, ModalOptions, TableComponent} from "@shared/components";
import {APIService, ToastService} from '@core/services';
import {PatientService} from '@core/services/patient.service';
import {Insurance} from '@core/classes/tables/insurance';
import {HTTPMethods, ModalTypes} from '@core/enums';
import {HttpHeaders} from '@angular/common/http';

@Component({
  selector: 'ncp-insurance-status-action',
    imports: [
        ButtonComponent,
        ModalComponent
    ],
  templateUrl: './insurance-status-action.component.html',
  styleUrl: './insurance-status-action.component.scss',
})
export class InsuranceStatusActionComponent  implements OnInit, AfterContentInit, OnDestroy {
  protected readonly toastService = inject(ToastService);
  protected readonly apiService = inject(APIService);
  protected readonly patientService = inject(PatientService);
  private readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);

  @ViewChild('mod') public mod!: ModalComponent;
  @ViewChild('btn') public btn!: ButtonComponent;

  protected data = model<Insurance>();
  protected allData = model<Insurance[]>();
  protected reloadData = model<() => {}>();
  protected index = input<number>();
  protected tbl = model<TableComponent<Insurance>>(new TableComponent());

  protected btnOptions = signal<ButtonOptions>(
    new ButtonOptions({
      id: 'action'
    })
  );
  protected modOptions = model<ModalOptions>(
    new ModalOptions({
      id: 'modal',
      type: ModalTypes.confirm,
    })
  );

  statusEffect = effect(() => {
    this.setConfirm();
  });

  setConfirm = () => {
    if(this.row?.version_id?.toString() !== this.patientService.version!.new?.toString()) {
      this.modOptions().title = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';
      this.modOptions().message = this.row?.status === 1 ? 'confirm_disable' : 'confirm_enable';
      this.btnOptions().icon = this.row?.status === 1 ? 'bi bi-file-earmark-minus' : 'bi bi-file-earmark-plus';
      this.btnOptions().class = '';
      this.btnOptions().tooltip = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';
      this.modOptions().onYes = this.changeStatus;
    } else {
      this.modOptions().title = 'delete_entry';
      this.modOptions().message = 'confirm_delete';
      this.btnOptions().icon = 'bi bi-trash3';
      this.btnOptions().class = 'btn-danger';
      this.btnOptions().tooltip = 'delete_entry';
      this.modOptions().onYes = this.deleteEntry;
    }
  }

  ngOnInit() {
    this.btnOptions().onClick = () => {
      this.setConfirm();
      this.btn.blur();
      this.mod.open();
    };
  }

  ngOnDestroy() {
    this.statusEffect.destroy();
  }

  ngAfterContentInit() {

  }

  get row() {
    return this.data();
  }
  set row(row) {
    this.data.set(row);
  }

  protected changeStatus = () => {
    this.apiService.call({
      path: '/insurance',
      headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
      type: HTTPMethods.PUT,
      body: {
        status: this.data()?.status === 1 ? 0 : 1,
        insurance_id: this.data()?.insurance_id,
        insurance_name: this.data()?.insurance_name,
        insurance_number: this.data()?.insurance_number,
        version_id: this.data()?.version_id
      }
    })?.subscribe(res => {
      if(res && res.status && res.status.toString() === '1') {
        let allData = this.allData() as Insurance[];
        allData[this.index()!].status = allData[this.index()!].status === 1 ? 0 : 1;
        this.row = allData[this.index()!];

        this.btnOptions().icon = this.row?.status === 1 ? 'bi bi-file-earmark-minus' : 'bi bi-file-earmark-plus';
        this.btnOptions().tooltip = this.row?.status === 1 ? 'disable_entry' : 'enable_entry';

        (this.tbl() as TableComponent<Insurance>).detectChanges();

        this.mod.close('success');
      }
    });
  }

  protected deleteEntry = () => {
    this.apiService.call({
      path: '/delete-insurance',
      headers: new HttpHeaders().set('pToken', this.patientService.pToken || ''),
      type: HTTPMethods.PUT,
      body: {
        status: this.data()?.status === 1 ? 0 : 1,
        insurance_id: this.data()?.insurance_id,
        insurance_name: this.data()?.insurance_name,
        insurance_number: this.data()?.insurance_number,
        version_id: this.data()?.version_id
      }
    })?.subscribe(res => {
      if (res && res.status && res.status.toString() === '1') {
        let allData = (this.tbl() as TableComponent<Insurance>).tableData;

        (this.tbl() as TableComponent<Insurance>).tableData = allData!.filter(item => {
          return !((item.insurance_id?.toString() === this.data()?.insurance_id?.toString()) &&
            (item.version_id?.toString() === this.data()?.version_id?.toString()))
        });

        (this.tbl() as TableComponent<Insurance>).reload().detectChanges();
        this.mod.close('success');
      }
    });
  };
}
